module.exports = __webpack_public_path__ + "img/top-bar.52c98bb8.png";